import React from 'react';
import { Button } from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

export default function QueryYearSelector({ paramName = 'year', defaultValue, style }) {
  const history = useHistory();
  const location = useLocation();
  
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const currentValue = queryParams[paramName] ? parseInt(queryParams[paramName]) : defaultValue;

  const handleChange = (newValue) => {
    const newQueryParams = { ...queryParams, [paramName]: newValue };
    const queryString = qs.stringify(newQueryParams);
    history.push(`${location.pathname}?${queryString}`);
  };

  const handlePrev = () => handleChange(currentValue - 1);
  const handleNext = () => handleChange(currentValue + 1);

  return (
    <div className="d-flex align-items-center gap-2" style={style}>
      <Button color="outline-secondary" size="sm" onClick={handlePrev}>◀</Button>
      <span className="fw-bold">{currentValue}年度</span>
      <Button color="outline-secondary" size="sm" onClick={handleNext}>▶</Button>
    </div>
  );
}